import React, { useContext, useEffect, useState } from 'react'
import { AccountContext } from '../contexts/AccountContext';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import _axios from '../axios';
import buildLink from '../urls';
import PopUp from '../components/Popup';
import PointsLoader from '../components/PointsLoader';
import { FaQuestionCircle } from 'react-icons/fa';

function Checkin() {
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [checkins, setCheckins] = useState([]);
    const [points, setPoints] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [stateAccount, dispatchAccount] = useContext(AccountContext);
    const [limit, setLimit] = useState(20);
    const [recommended, setRecommended] = useState([]);
    const [earnedPoint, setEarnedPoint] = useState(0);
    const [searchParams] = useSearchParams();
    const [totalPages, setTotalPages] = useState(0);
    const navigate = useNavigate()

    const getCheckinInf = () => {
        const page = searchParams.get("page") ?? 0;
        let pageparam = "";
        if (page) {
          pageparam = "&page=" + page;
          setPage(page);
        } else {
          setPage(0);
        }
        console.log(page);
        setLoading(true);
        _axios
          .get(
            buildLink("checkin", undefined, window.innerWidth) +
              pageparam +
              "&limit=" +
              limit
          )
          .then((response) => {
            setLoading(false);
           
              setEarnedPoint(response.data.data.pop_up.checked_points);
              setShowPopup(response.data.data.pop_up.checked_in);
       
    
            setCheckins(response.data.data.checkins);
            setPoints(response.data.data.points);
            // _axios
            //   .get(
            //     buildLink("getRecommandedPoints") + pageparam + "&limit=" + limit
            //   )
            //   .then((res) => {
            //     setTotalPages(res.data.data.suggestions.total_pages);
            //     setRecommended(res.data.data.suggestions.products);
            //   });
          });
      };
    
      function pageSetter(page) {
        setPage(page["selected"] + 1);
        navigate(
          `/account/checkin?&page=${page["selected"] + 1}&limit=${limit}`
        );
      }
      useEffect(() => {
        _axios
          .get(buildLink("get_account", undefined, window.innerWidth))
          .then((response) => {
            if (!response.data.success) {
              dispatchAccount({ type: "setLoading", payload: false });
              if (!stateAccount.loading && !stateAccount.loged) {
                navigate("/");
              }
            } else {
                getCheckinInf();
            }
          });
      }, [window.location.href]);

  return (
    <>
         <div className="pb-2">
      <div className="flex-row md:flex">
        {loading ? (
          <div className="flex justify-center w-full">
            <PointsLoader />
          </div>
        ) : (
          <div className="flex relative justify-center overflow-hidden bg-white h-full w-full">
            <div className="w-full md:px-0 mb-5 relative">
              <div>
                <div className="relative justify-center flex flex-col ">
                  <div className="max-md:text-left max-md:justify-start max-md:mx-0 max-md:ml-3 flex my-8 justify-center text-center flex-col w-fit mx-auto">
                    <h1 className="text-dblackk text-3xl font-[900]">
                      MY POINTS
                    </h1>
                    <Link to={`/rewards`}  className="underline text-sm text-dlabelColor flex flex-row gap-2 justify-center">
                      Learn more about English Home points <span className="h-fit my-auto"><FaQuestionCircle className="text-dbase text-sm" /></span>
                    </Link>
                  </div>

                  <div className="w-full h-32 bg-dgrey rounded-md">
                    <div className="flex flex-row text-center justify-center max-md:px-8 px-24 py-7">
                      <h2 className="text-dlabelColor">
                        <span className="text-dbase text-5xl">{points}</span> Points
                      </h2>
                    </div>
                  </div>

                  <p className="my-5 text-sm text-dlabelColor flex flex-row gap-2 justify-center">
                    Check in every day to get points gift
                  </p>

                  <div className="max-md:gap-5 gap-10 justify-center w-full h-full flex flex-wrap py-5">
                    {checkins &&
                      checkins.map((checkin) => (
                        <div className="flex-col justify-center gap-5" key={checkin.date}>
                          <div className={`cursor-cell flex justify-center text-center w-12 h-12 rounded-full ${checkin.checked_in ? ' bg-dborderblack1 text-white' : 'bg-gray-300 text-black'} relative `}>
                            <p className="my-auto mx-auto">{checkin.point}</p>
                          </div>
                          <div className="text-sm w-fit mx-auto text-dlabelColor">
                            {checkin.date}
                          </div>
                        </div>
                      ))}
                  </div>
{/* 
                  {recommended && (
                    <div className="flex flex-col container">
                      <div className="pr-semibold text-d20 text-dblack my-6">Recommended</div>
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                        {recommended.map((item, index) => (
                          <SingleProduct key={index} item={item} noAddCart={true} />
                        ))}
                      </div>
                      {totalPage > 0 && (
                        <ReactPaginate
                          pageCount={Math.ceil(totalPage / limit)}
                          containerClassName={"pagination"}
                          onPageChange={pageSetter}
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={1}
                          previousLabel={"<"}
                          nextLabel={">"}
                          activeClassName={"active-pagination"}
                          forcePage={page ? parseInt(page) - 1 : 0}
                        />
                      )}
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

        <PopUp
          isOpen={showPopup}
          onClose={() => {
            setShowPopup(false);
          }}
          title={''}
        >
         <div className=" w-full h-full relative justify-center text-center flex flex-col gap-4">
          <div className="   mx-auto text-dborderblack2 rounded-full flex items-center justify-center">
            <span className=" text-2xl">+1</span>
          </div>
          <h2 className=" text-2xl font-bold">
            You've earned{" "}
            <span className=" text-dbase  font-extrabold">{earnedPoint}</span>{" "}
            points!
          </h2>
          <span className=" text-md  text-dlabelColor">
            Check in for 2 more days to get a surprise reward.
          </span>
          <button
            onClick={() => setShowPopup(false)}
            className=" text-white bg- mt-4  px-4 py-1 rounded-md text-xl"
            style={{backgroundColor: "#002b5c"}}
          >
            Confirm
          </button>
        </div>

        </PopUp>
    </>
  )
}

export default Checkin